export default __webpack_public_path__ + "static/media/banner.b49ae3fc.jpg";